import { render, staticRenderFns } from "./RatingsAndReviews.vue?vue&type=template&id=26d37ae6&scoped=true"
import script from "./RatingsAndReviews.vue?vue&type=script&lang=js"
export * from "./RatingsAndReviews.vue?vue&type=script&lang=js"
import style0 from "./RatingsAndReviews.vue?vue&type=style&index=0&id=26d37ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d37ae6",
  null
  
)

export default component.exports